import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';
import {
  dateIsEqualOrIsAfterNextDay,
  isValidMaxDecimalPlaces,
  convertToNullWhenNaN
} from 'utils/validation';

const t = i18n.getFixedT(getLocale(), 'common');

const MAX_DECIMAL_PLACES = 2;

export const schema = yup.object({
  claId: yup
    .number()
    .required(t('salaryScales.grid.errors.claCodeRequired'))
    .typeError(t('salaryScales.grid.errors.claCodeRequired')),
  scale: yup.string().required(t('salaryScales.grid.errors.scaleRequired')),
  salaryNr: yup.number().transform(convertToNullWhenNaN).nullable(),
  seniority: yup
    .number()
    .transform(convertToNullWhenNaN)
    .nullable()
    .required(t('salaryScales.grid.errors.seniorityRequired')),
  periodSalary: yup
    .number()
    .transform(convertToNullWhenNaN)
    .nullable()
    .min(0)
    .max(9999.99)
    .test(
      'isValidMaxDecimalPlaces',
      t('validationNumberMaxDecimals', { number: MAX_DECIMAL_PLACES }),
      (value) => isValidMaxDecimalPlaces(value, MAX_DECIMAL_PLACES)
    )
    .required(t('salaryScales.grid.errors.periodSalaryRequired')),
  valid: yup.object({
    from: yup
      .date()
      .required(t('validationFieldRequired', { name: t('validFrom') }))
      .nullable()
      .typeError(t('validationDateInvalid', { name: t('validFrom') }))
      .default(null),
    to: yup
      .date()
      .required(t('validationFieldRequired', { name: t('validTo') }))
      .nullable()
      .typeError(t('validationDateInvalid', { name: t('validTo') }))
      .default(null)
      .test(
        'isAfterStart',
        t('dateRangeMismatch', {
          startDate: t('validFrom'),
          endDate: t('validTo')
        }),
        dateIsEqualOrIsAfterNextDay
      )
  })
});
